// extracted by mini-css-extract-plugin
export default {"formContainer":"form_formContainer__Jawl4","form":"form_form__m2IFf","inputs":"form_inputs__tsu3-","wraper":"form_wraper__DaaC-"};